import * as React from "react";
import { ButtonProps } from "../button/types";
import { ImageProps } from "../image/types";
import { ProductRefType } from "../../../context/product-context/types";

export const BasicAccountApplicationItemClassNameBase =
  "scd-account-application-item";

export interface StandardBasicAccountApplicationItemProps {
  product: ProductRefType;
  image: React.ReactElement<ImageProps>;
  title: string;
  button?: React.ReactElement<ButtonProps>;
}
